export default __webpack_public_path__ + "static/media/QOS-Master-transparent.6aeb6663.png";